<template>
    <app-modal-view @close="$emit('close')">
        <template #body>
            <div
                v-for="(section, title) in settingsModel"
                :key="title"
                class="py-2"
                @click="activeDropdown = undefined"
            >
                <p
                    v-t="`Community.settings_${title}_title`"
                    class="title is-3"
                ></p>
                <div
                    v-for="(value, option) in section"
                    :key="option"
                    class="box"
                >
                    <div class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <p
                                    v-t="`Community.settings_${option}`"
                                    class="title is-6"
                                ></p>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <label
                                    v-if="typeof section[option] == 'boolean'"
                                    class="switch"
                                >
                                    <input
                                        v-model="activeSettings[option]"
                                        type="checkbox"
                                    />
                                    <span class="slider round"></span>
                                </label>
                                <div
                                    v-else
                                    :class="{
                                        'is-active': option == activeDropdown,
                                    }"
                                    class="dropdown"
                                >
                                    <div
                                        class="dropdown-trigger"
                                        @click.stop="activeDropdown = option"
                                    >
                                        <button
                                            class="button"
                                            aria-haspopup="true"
                                            aria-controls="dropdown-menu"
                                        >
                                            <span>
                                                {{
                                                    $t(
                                                        `Constants.${activeSettings[option]}`
                                                    ) || $t('Buttons.select')
                                                }}
                                            </span>
                                            <span class="icon is-small">
                                                <i
                                                    class="fas fa-angle-down"
                                                    aria-hidden="true"
                                                ></i>
                                            </span>
                                        </button>
                                    </div>
                                    <div
                                        id="dropdown-menu"
                                        class="dropdown-menu"
                                        role="menu"
                                    >
                                        <div class="dropdown-content">
                                            <a
                                                v-for="constant in value"
                                                :key="constant"
                                                v-t="`Constants.${constant}`"
                                                class="dropdown-item"
                                                @click="
                                                    activeSettings[option] =
                                                        constant
                                                "
                                            ></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p
                        v-if="$te(`Community.settings_${option}_description`)"
                        v-t="`Community.settings_${option}_description`"
                        class="subtitle is-6"
                    ></p>
                </div>
            </div>
        </template>
        <template #footer>
            <button
                v-t="'Buttons.save'"
                :class="{ 'is-loading': savingChanges }"
                class="button"
                @click="saveChanges"
            ></button>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import _ from 'underscore';
import { updateCommunity } from '@/services/API';
export default {
    components: {
        AppModalView,
    },
    props: {},
    data() {
        return {
            activeDropdown: undefined,
            activeSettings: JSON.parse(
                JSON.stringify(this.$store.getters.community.settings)
            ),
            settingsModel: {
                feed: {
                    feed_allowed_posts: ['ONLY_ADMINISTRATORS', 'ALL'],
                    feed_posts_requires_validation: false,
                },
            },
            savingChanges: false,
        };
    },
    methods: {
        async saveChanges() {
            this.savingChanges = true;
            const updatedCommunity = { ...this.$store.getters.community };
            updatedCommunity.settings = this.activeSettings;
            const result = await updateCommunity(
                this.$store.getters.community._id,
                updatedCommunity
            ).finally(() => {
                this.savingChanges = false;
            });

            this.$store.commit('SET_COMMUNITY', result.data);
        },
    },
};
</script>

<style></style>
